import React from "react";
import { Modal, Button, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import tem from "../../assest/template.png";
import { useSelector } from "react-redux";

const TemplateDesignes = ({ visible, onCancel, onSave,setSelecteddomain,setSelectedloginTempalte }) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState("");

  const AllDomain = useSelector((state) => state?.DomainReducer?.AllDomain);
  const AllLoginTemplate = useSelector(
    (state) => state?.LoginTemplateReducer?.AllLoginTemplate
  );

  return (
    <Modal open={visible} onCancel={onCancel} width={900} footer={null}>
      <div className="pt-8 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center gap-6">
          <h5 className="text-xl font-medium text-[#4A4D54]">
            Design Templates for Campaign
          </h5>
          <div className="max-w-xs w-full">
            <Input
              placeholder="Search templates..."
              prefix={<SearchOutlined />}
            />
          </div>
        </div>

        {/* Select Campaign Link */}
        <label className="text-sm text-[#4A4D54]">
          Select Your Campaign Link
        </label>
        <Select
          style={{ width: "100%", height: "40px" }}
          placeholder="Select Link"
          onChange={(value) => setSelecteddomain(AllDomain?.data?.find((item) => item._id === value))}
        >
          {AllDomain?.data?.map((item, index) => (
            <Select.Option key={index} value={item._id}>
              {item.url}
            </Select.Option>
          ))}
        </Select>

        {/* Scrollable Template List */}
        <div className="max-h-[400px] overflow-y-auto space-y-4 pr-2">
          {AllLoginTemplate?.data?.map((item) => (
            <div
              key={item.id}
              className={`flex items-center p-4 border border-gray-300  rounded-3xl gap-4 cursor-pointer ${
                selectedTemplate === item._id ? "bg-red-50" : ""
              }`}
              onClick={() => {
                setSelectedTemplate(item._id);
                setSelectedloginTempalte(item);
              }}
              
              
              style={{
                border: `1px solid ${
                  selectedTemplate === item._id ? "#EF4444" : "#d1d5db"
                }`,
              }}
            >
              <div>
                <img
                  alt={item.name}
                  src={tem}
                  className="rounded-2xl object-cover"
                />
              </div>
              <div className="w-full">
                <h5 className="text-xl font-medium text-[#3A3B3F]">
                  {item.name}
                </h5>
                <p className="text-sm text-[#6D727D]">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-between gap-3 flex-wrap">
          <Button
            onClick={onCancel}
            size="large"
            danger
            className="rounded-full max-w-[150px] h-14 w-full"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            type="primary"
            size="large"
            danger
            className="rounded-full max-w-[150px] h-14 w-full"
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TemplateDesignes;
